import { FC } from 'react';
import { NavigateProps, useNavigate } from 'react-router-dom';

import Link, { LinkProps } from '../v2/components/Text/Link';

// Local Typings
interface NavigationOptions {
  replace?: NavigateProps['replace'];
  state?: NavigateProps['state'];
}
export interface RouterLinkProps extends LinkProps {
  navigationOptions?: NavigationOptions;
  onBeforeNavigate?: () => void;
  to?: NavigateProps['to'];
}

// Component Definition
const RouterLink: FC<RouterLinkProps> = ({
  disabled,
  navigationOptions,
  onBeforeNavigate,
  to,
  ...props
}) => {
  const navigate = useNavigate();

  function handleClick() {
    onBeforeNavigate?.();

    if (to) {
      navigate(to,
        navigationOptions);
    } else if (props.href) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      props.target
        ? window.open(props.href,
          props.target)
        : window.location.href = props.href;
    } else if (props.onClick) {
      props.onClick();
    }
  }

  return (
    <Link
      {...props}
      disabled={disabled}
      onClick={handleClick}
    />
  );
};

export default RouterLink;
